import { render, staticRenderFns } from "./contentCourseExamWordSearchGame.vue?vue&type=template&id=12b6f5ee&"
import script from "./contentCourseExamWordSearchGame.vue?vue&type=script&lang=js&"
export * from "./contentCourseExamWordSearchGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports